import axios from 'axios';
import { isLoggedIn } from '../auth';

export function getJobList(careerId) {
	if (isLoggedIn()) {
		return axios.get(`/v1/jobs?career_id=${careerId}`);
	}
	return Promise.resolve(new Response(
		{ message: 'Unauthorised' },
		{ status: 403, statusText: 'Unauthorised' }
	));
}

export function getJobDetails(id) {
	if (isLoggedIn()) {
		return axios.get(`/v1/jobs/${id}`);
	}
	return Promise.resolve(new Response(
		{ message: 'Unauthorised' },
		{ status: 403, statusText: 'Unauthorised' }
	));
}

/**
 * Search for a job
 * @param {string} query - query string
 * @returns {Promise} jobs - a promise of jobs to be resolved.
 */
export function searchJobs(query) {
	if (isLoggedIn()) {
		return axios.get(`/v1/jobs/search?query=${query}`);
	}
	return Promise.resolve(new Response({
		message: 'Unauthorised'
	}, {
		status: 403,
		statusText: 'Unauthorised'
	}));
}

/**
 * Applies for a job
 * @param {Number} id - id of job
 * @param {Object} data - object with the user ID
 * @returns {Promise} a promise of job application
 */
export function jobApplication(id, data) {
	if (isLoggedIn()) {
		return axios.post(`v1/jobs/${id}/apply`, data);
	}
	return Promise.resolve(new Response({
		message: 'Unauthorised'
	}, {
		status: 403,
		statusText: 'Unauthorised'
	}));
}

/**
 * Fetches a list of job applicants
 * @returns {promise} a promise of job applicants
 */
export function getJobApplicants(id) {
	if (isLoggedIn()) {
		return axios.get(`/v1/jobs/${id}/applicants`);
	}
	return Promise.resolve(new Response({
		message: 'Unauthorised'
	}, {
		status: 403,
		statusText: 'Unauthorised'
	}));
}

/**
 * Uploads an applicant CV
 * @returns {promise} a promise of job applicants
 */
export function uploadCv(file) {
	if (isLoggedIn()) {
		return axios.post('/v1/jobs/cv', file);
	}
	return Promise.resolve(new Response({
		message: 'Unauthorised'
	}, {
		status: 403,
		statusText: 'Unauthorised'
	}));
}
